<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 17:40:07
-->
<template>
    <div class="add-danwei">
        <el-form ref="ruleForm" :model="viewData" label-width="100px">
            <el-form-item label="车牌号" prop="first_word">
                {{ viewData.car_number }}
            </el-form-item>
            <el-form-item label="车辆图片" prop="">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="$adddom(viewData.car_pic)"
                    :preview-src-list="[$adddom(viewData.car_pic)]"
                >
                </el-image>
            </el-form-item>
            <el-form-item label="所有者" prop="">
                {{ viewData.user && viewData.user.nickname }}
            </el-form-item>
            <el-form-item label="所有者图片" prop="">
                <el-image
                    v-if="viewData.user"
                    style="width: 100px; height: 100px"
                    :src="$adddom(viewData.user.avatar)"
                    :preview-src-list="[$adddom(viewData.user.avatar)]"
                >
                </el-image>
            </el-form-item>
            <el-form-item label="所有者电话" prop="">
                {{ viewData.user && viewData.user.phone }}
            </el-form-item>
            <el-form-item label="所属小区" prop="">
                {{ viewData.user_resource && viewData.user_resource.commName }}
            </el-form-item>
            <el-form-item label="所属资源" prop="">
                {{
                    viewData.user_resource &&
                    viewData.user_resource.resourceCode
                }}
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button
                style="
                    min-width: 117px;
                    background: #1067e0;
                    font-size: 16px;
                    border-color: #1067e0;
                "
                size="mini"
                type="primary"
                @click="$emit('onUpdateDrawer', -1)"
                >取消</el-button
            >
        </div>
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/car";
import Qu from "@/api/tianzheng/Qu";
import Tinymce from '@/components/Tinymce'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            thumbList: [],
            imageDefaultList: "",
            thumbList1: [],
            imageDefaultList1: "",
            showUpload:false,
            optionList: [],
            viewData: {
                id:'',
                name: "",
                commId: "",
                content: "",
                source: "",
                publish_at: "",
                sort: 0,
                status: 1,
            },
            rules: {
                title1: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                commId1: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                content1: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        Tinymce,
        ImageUpload
    },
    created() {
        this.getSelectCity()
    },
    methods: {
        // 更新图片
        onUpdateImg1 (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList1 = thumbList;
        },
        // 更新图片
        onUpdateImg (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this
            this.viewData = {
                id: "",
                name: "",
                status: 1,
                sort: 0,
            }
            this.showUpload = true
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        // if (that.viewData.content) {
                        //     that.$refs["tinymce"].setContent(this.viewData.content);
                        // } else {
                        //     that.$refs["tinymce"].setContent('');
                        // }
                        if (that.viewData.thumb) {
                            let arr = []
                            let obj = {
                                    name: that.viewData.thumb,
                                    path: that.viewData.thumb,
                                    url: that.$publicData.imgUrl + that.viewData.thumb,
                                }
                                arr.push(obj);
                                that.imageDefaultList1 =  arr
                        }
                        if (that.viewData.pic_arr.length > 0) {
                            let imgList = [];
                            let thumb_arr = that.viewData.pic_arr;
                            thumb_arr.forEach((ele, index) => {
                                let obj = {
                                    name: ele,
                                    path: ele,
                                    url: that.$publicData.imgUrl + ele,
                                }
                                imgList.push(obj);
                            })
                            // 回显图
                            that.imageDefaultList = imgList
                            // console.log(that.imageDefaultList)
                        };
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            if (this.$refs["tinymce"]) {
                this.$refs["tinymce"].setContent('');
            }
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
